module.exports = __webpack_public_path__ + "static/media/hs_09.2a48d6c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_09.jpg
// module id = 5940
// module chunks = 0